import {setWorkerUrl} from 'maplibre-gl';

export function configureMapLibre(): void {
  const workerUrl = new URL(
    'assets/maplibre/maplibre-gl-worker.mjs',
    document.baseURI
  ).href;

  setWorkerUrl(workerUrl);
}
